module.exports = __webpack_public_path__ + "static/media/emoji_flame.753ecfa4.png";